import {Component, OnInit, Renderer2} from '@angular/core';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-jinni-error-modal',
  templateUrl: './jinni-error-modal.component.html',
  styleUrls: ['./jinni-error-modal.component.scss']
})
export class JinniErrorModalComponent implements OnInit {
  errorDataSub: Subscription;
  errorID: any;

  constructor(private renderer: Renderer2, public subscriptionsService: SubscriptionsService) { }

  ngOnInit() {
    this.errorDataSub = this.subscriptionsService.getUniversalJinniErrorModalData().subscribe(data => {
      this.errorID = data;
    });
  }

  closeModal() {
    this.subscriptionsService.updateOpenUniversalJinniErrorModal(false);
    this.subscriptionsService.updateUniversalJinniErrorModalData(null);
    this.subscriptionsService.updateTriggeredEndGameSessionIG(true);
    this.renderer.removeClass(document.body, 'modal-open');
  }

}
